import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { connect } from "react-redux";
import { compose } from "redux";
import Grid from '@material-ui/core/Grid';
import { fetchUsers, fetchCoaches } from "../actions/UserAction"
import { addClass, fetchClass, updateClass } from "../actions/ClassAction";
import Button from '@material-ui/core/Button';
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
import ClassModel from '@material-ui/core/Modal';
import BookingSessionModel from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { fetchPrograms } from "../actions/ProgramAction";
import { getBookedTime } from "../actions/BookedAction";
import moment from "moment";
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { fetchLibrary } from '../actions/LibraryAction';
import { Link } from 'react-router-dom'
import { Chip, Toolbar } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import { getbookingTimeSlot } from "../actions/BookingTimeSlotAction";
import { postBookingTime } from "../actions/BookedAction";
import { DatePicker, TimePicker } from 'material-ui-pickers';

const CustomTableCell = withStyles(theme => ({
    head: {
        //backgroundColor: theme.palette.common.black,
        color: "#2926ac",
        fontWeight: "bold",
        fontSize: 13
    },
    body: {
        fontSize: 14,

    },
}))(TableCell);
const { innerWidth, innerHeight } = window;
const styles = theme => ({
    root: {
        width: '98%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
        textAlign: "center",
        marginLeft: 10
    },

    button: {
        margin: theme.spacing.unit,
        textTransform: "none",
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'white'
    },

    paper: {
        position: 'absolute',
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        outline: 'none',
        borderRadius: 5,
        maxHeight: innerHeight - (theme.spacing.unit * 2),
        // borderBottom: '5px solid red'
    },
   
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-54px' : '-34px',
        marginTop: innerWidth >= 480 ? '-54px' : '-44px'
    },
    

    textField: {
       
        margin: 0
    },
    textField1: {
        width: 720,
        marginTop: -1,
        marginLeft: 8
    },
    inputStyle: {
        padding: '12px 1px',
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.87)'
    },
    formControl1: {
        margin: theme.spacing.unit,
        
    },
    selectControll: {
        margin: theme.spacing.unit,
        width: 200,
        marginTop: 21,
        marginLeft: 8
    },
    gradientButton: {
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        },
        

    },

    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    cancelbutton: {
        margin: theme.spacing.unit,
    },


});

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class ClassView extends Component {
    constructor() {
        super();
        this.state = {
            mode: null,
            open: false,
            bookingSessionModelOpen: false,
            bookingSessionViewModelOpen: false,
            program_name: null,
            description: null,
            program_id: null,
            program_name_error: false,
            editProgram: {},
            classModelOpen: false,
            taken_by: null,
            class_name: '',
            class_description: '',
            library_id: null,
            bookable_id: null,
            start_time: null,
            created_by: '',
            end_time: null,
            day_of_week: '',
            date: null,
            classId: null,
            // description: '',
            library_id_error: false,
            bookable_id_error: false,
            start_time_error: false,
            end_time_error: false,
            class_name_error: false,
            day_of_week_error: false,
            date_error: false,
            taken_by_error: false,
            libraries: [],
            bookings: [],
            library: null,
            booking: null,
            booked_time: [],
            selectedOption: null,
            booking_slot_time: [],
            bookedTime: [],


        };
    }



    componentDidMount() {
        this.props.dispatch(fetchUsers())
        this.props.dispatch(fetchCoaches())
        this.props.dispatch(fetchClass())
        this.props.dispatch(fetchPrograms())
        this.props.dispatch(fetchLibrary())
        this.props.dispatch(getBookedTime());
        this.props.dispatch(getbookingTimeSlot());
        this.setState({ program_id: parseInt(this.props.match.params.id) })
    }

    handleOpen = (param, classEntry) => {
        this.setState({ classModelOpen: true, mode: param })
        if (param === "edit") {
            this.setState({ class_name: classEntry.class_name, class_description: classEntry.description, program_id: parseInt(this.props.match.params.id), taken_by: classEntry.taken_by, classId: classEntry.id, created_by: classEntry.created_by })
        }
    };

    bookingSessionModelOpenMethod = (id, classEntry) => {
        this.setState({ bookingSessionModelOpen: true, classId: id })
        const booked = this.props.bookedTimes.filter((bookedtime) => bookedtime.booking_for === "class" && bookedtime.bookable_id === id)
        this.setState({ bookedTime: booked })
    };

    bookingSessionModelViewOpenMethod = (id, classEntry) => {
        this.setState({ bookingSessionViewModelOpen: true, classId: id })
    };


    handleClose = () => {
        this.setState({
            program_name: null,
            description: null,
            program_name_error: false,
            classModelOpen: false,
            bookingSessionModelOpen: false,
            bookingSessionViewModelOpen: false,
            library_id: null,
            start_time: null,
            end_time: null,
            day_of_week: '',
            date: null,
            library_id_error: false,
            start_time_error: false,
            end_time_error: false,
            day_of_week_error: false,
            date_error: false,
            booked_time: [],
            booking_slot_time: [],
            inavlid_end_time_error: false,


        });
    };

    dateChange = event => {
        let day_of_week = moment(event).format("dddd")
        let booked_times = (this.props.bookedTimes.length > 0 ? this.props.bookedTimes.filter(time => (moment(time.date).format('MMDDYYYY') === moment(event).format('MMDDYYYY')) && (time.library_id === this.state.library_id)) : [])
        let booking_slot_time = (this.props.bookingTimeSlot.length > 0 ? this.props.bookingTimeSlot.filter(time => (time.day_of_week === day_of_week) && (time.library_id === this.state.library_id)) : [])
          this.setState({ date: event, day_of_week: day_of_week, booked_time: booked_times, booking_slot_time: booking_slot_time, date_error: false })
        
      }

    libraryDropDownAction = event => {
        let booked_times = (this.props.bookedTimes.length > 0 ? this.props.bookedTimes.filter(time => (moment(time.date).format('MMDDYYYY') === moment(this.state.date).format('MMDDYYYY')) && (time.library_id === event.target.value)) : [])
        let booking_slot_time = (this.props.bookingTimeSlot.length > 0 ? this.props.bookingTimeSlot.filter(time => (time.day_of_week === this.state.day_of_week) && (time.library_id === event.target.value)) : [])
        this.setState({ library_id: event.target.value, booked_time: booked_times, booking_slot_time: booking_slot_time, library_id_error: false })
    }


    classFormSubmit = (mode) => {
        let isError = false;
        if (this.state.taken_by === null) {
            this.setState({ taken_by_error: true })
            isError = true
        }
        if (this.state.class_name === "") {
            this.setState({ class_name_error: true })
            isError = true
        }
        if (isError === false) {
            let classValues = {}
            classValues.program_id = parseInt(this.props.match.params.id)
            classValues.class_name = this.state.class_name
            classValues.taken_by = this.state.taken_by
            classValues.description = this.state.class_description
            classValues.status = "Active"
            if (this.state.mode === "edit") {
                classValues.id = this.state.classId
                classValues.created_by = this.state.created_by
            }
            this.state.mode === "add" ? this.props.dispatch(addClass(this.state, classValues)) : this.props.dispatch(updateClass(classValues, this.state.classId))
            this.setState({
                classModelOpen: false,
                taken_by: null,
                program_id: "",
                class_name: '',
                class_name_error: false,
                class_description: '',
                classId: ""
            })
        }
    }

    bookingSessionFormSubmit = () => {
        let isError = false;
        if (this.state.library_id === null) {
            this.setState({ library_id_error: true })
            isError = true
        }
        if (this.state.date === "" || this.state.date === null) {
            this.setState({ date_error: true })
            isError = true
        }
        if (this.state.start_time === null) {
            this.setState({ start_time_error: true })
            isError = true
        }
        if (this.state.end_time === null) {
            this.setState({ end_time_error: true })
            isError = true
        }

        if ((this.state.end_time < this.state.start_time)) {
            this.setState({ inavlid_end_time_error: true })
            isError = true
        }

        if (isError === false) {
            let booking = {}
            booking.start_time = moment(this.state.start_time).format()
            booking.end_time = moment(this.state.end_time).format()
            booking.library_id = this.state.library_id
            booking.bookable_id = this.state.classId
            booking.day_of_week = this.state.day_of_week
            booking.date = this.state.date
            booking.booking_for = 'class'
            booking.description = this.state.description
            console.log("*******booking***********" + JSON.stringify(booking))
            this.props.dispatch(postBookingTime(this, booking))
        }
    }

    coachNameDisplay(id) {
        const coach = this.props.coaches.filter((user) => user.id === id)[0]
        return coach.first_name + " " + coach.last_name

    }

    returnStartTimeOREndTime(date,startTimeOrEndTime){
     console.log("**********************date***********",date)
     var returnDate =null
      let formatDate = moment(date).format("YYYY-MM-DD")
      let formatTime = moment(startTimeOrEndTime).format("HH:mm")
      let dateandtimeconcatenation = formatDate +" "+ formatTime 
      console.log("**********************dateandtimeconcatenation***********",dateandtimeconcatenation)
      returnDate = moment(dateandtimeconcatenation, 'YYYY-MM-DD HH:mm')
      console.log("**********************myDate***********",returnDate)
      return returnDate
   }


    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div>
                    <Grid container spacing={12} >
                        <Grid item xs={4} sm={4}>
                            <Toolbar>
                                <Button component={Link}
                                    to={{
                                        pathname: `/teams`,
                                        state: {
                                            selectedTab: 2
                                        }
                                    }} variant="contained" color="secondary" size="small">
                                    Go back
                                </Button>
                            </Toolbar>
                        </Grid>
                        <Grid item xs={4} sm={4} >
                            <Toolbar style={{ textAlign: 'center', justifyContent: 'center' }}>
                                <Typography variant={"h6"}>
                                    Class
                                </Typography>
                            </Toolbar>
                        </Grid>
                        <Grid item xs={4} sm={4}>
                            {/* {innerWidth >= 480 ?
                            <Toolbar>
                                <Button component={Link} 
                                    to={{
                                        pathname: `/teams`,
                                        state: {
                                            selectedTab: 2
                                        }
                                    }} variant="contained" color="secondary" size="small" style={{ float: "right"}} > 
                                    Go back
                                </Button>
                                
                                <Button variant="contained" color="secondary" size="small" className={classes.gradientButton} style={{ float: "right"}} onClick={() => { this.handleOpen("add", {}) }} > Add Class</Button>
                            </Toolbar>   
                            :
                            <Toolbar >                       
                                <Button component={Link}
                                    to={{
                                        pathname: `/teams`,
                                        state: {
                                            selectedTab: 2
                                        }
                                    }} variant="contained" color="secondary" size="small" style={{ float: "right" }} > 
                                    Go back
                                </Button>

                                <Button variant="contained" color="secondary" size="small" className={classes.gradientButton} onClick={() => { this.handleOpen("add", {}) }} > Add Class</Button>
                            </Toolbar> 
                            } */}
                            <Toolbar style={{ float: "right" }}>
                                <Button variant="contained" color="secondary" size="small" className={classes.gradientButton} onClick={() => { this.handleOpen("add", {}) }} > Add Class</Button>
                            </Toolbar>
                        </Grid>
                    </Grid>
                </div>
                <Paper className={classes.root}>
                    {this.props.classObject.length > 0 ?
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <CustomTableCell>Name</CustomTableCell>
                                    <CustomTableCell align="left">Description</CustomTableCell>
                                    <CustomTableCell align="left">Class Taken</CustomTableCell>
                                    <CustomTableCell align="center">Actions</CustomTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {this.props.classObject.length > 0 && this.props.classObject.filter((filterClass) => filterClass.program_id === parseInt(this.props.match.params.id)).map(classValues => (
                                    <TableRow className={classes.row} >
                                        <CustomTableCell align="left">{classValues.class_name}</CustomTableCell>
                                        <CustomTableCell align="left">{classValues.description}</CustomTableCell>
                                        {this.props.coaches.length > 0 ?
                                            <CustomTableCell align="left">{this.coachNameDisplay(classValues.taken_by)}</CustomTableCell> : null}
                                        <CustomTableCell align="center">
                                            <Button variant="contained" color="secondary" size="small" onClick={() => { this.handleOpen("edit", classValues) }} className={classes.cancelbutton}    >
                                                Edit
                                             </Button>
                                            <Button variant="contained" color="primary" size="small" onClick={() => { this.bookingSessionModelOpenMethod(classValues.id, classValues) }} >
                                                Book A Session
                                            </Button>
                                        </CustomTableCell>
                                    </TableRow>))}
                            </TableBody>
                        </Table>
                        : null}
                </Paper>
                <ClassModel
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.classModelOpen}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        <Typography variant="h6"  >
                            {this.state.mode === "add" ? "Add Class" : "Edit Class"}
                        </Typography>
                        <Grid container spacing={8}>
                            <Grid item xs={innerWidth > 480 ? 6 : 12} >
                                <TextField
                                    id="standard-name"
                                    label="Class Name"
                                    fullWidth
                                    required
                                    error={this.state.class_name_error === true ? true : false}
                                    helperText={this.state.class_name_error === true ? "Please Enter Class Name" : false}
                                    className={classes.textField}
                                    value={this.state.class_name || ""}
                                    onChange={(event) => this.setState({ class_name: event.target.value, })}
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 6 : 12} >
                                <form autoComplete="off">
                                    <FormControl fullWidth>
                                        <InputLabel required shrink htmlFor="Coach Name" error={this.state.taken_by_error === true ? true : false} >Class Taken</InputLabel>
                                        <Select
                                            required
                                            style={{ marginTop: 26 }}
                                            error={this.state.taken_by_error === true ? true : false}
                                            value={this.state.taken_by || ""}
                                            onChange={(event) => this.setState({ taken_by: event.target.value })}
                                            inputProps={{
                                                name: 'Coach Name',
                                                id: 'coach_name',
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        >

                                            {this.props.coaches.length > 0 && this.props.coaches.filter((user) => user.user_type === 'COACH').map(u => (
                                                <MenuItem key={u.id} value={u.id}>{u.first_name} {u.last_name}</MenuItem>
                                            ))}

                                            {
                                                this.props.coaches.length === 0 &&
                                                <MenuItem key={0} value={0}>{`Select Coach`}</MenuItem>
                                            }

                                        </Select>
                                        <FormHelperText error> {this.state.taken_by_error === true ? "Please Select Coach Name" : false} </FormHelperText>
                                    </FormControl>
                                </form>
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 12 : 12} >
                                <TextField
                                    id="standard-name"
                                    label="Class Description"
                                    fullWidth
                                    //  multiline
                                    // className={classes.textField1}
                                    value={this.state.class_description || ""}
                                    onChange={(event) => this.setState({ class_description: event.target.value, })}
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button onClick={this.handleClose} variant="contained" color="secondary" size="small" className={classes.cancelbutton}>
                                        cancel
                                    </Button>
                                    <Button onClick={this.classFormSubmit} variant="contained" size="small" className={classes.button}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </ClassModel>
                <BookingSessionModel
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.bookingSessionModelOpen}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        <Typography variant="h6" style={{ marginBottom: 18 }} >
                            Class Booking
 
                            {this.state.booking_slot_time.length > 0 ?
                                this.state.booking_slot_time[0].status === "ACTIVE" ?
                                    <Typography style={{ float: "right", color: "green" }}>Library open time:
                                {/* {this.state.booking_slot_time[0].start_time} - {this.state.booking_slot_time[0].end_time} */}
                                        {moment(this.state.booking_slot_time[0].start_time, "hh:mm:ss").format('LT')} - {moment(this.state.booking_slot_time[0].end_time, "hh:mm:ss").format('LT')}
                                    </Typography> :
                                    <Typography style={{ float: "right", color: "red" }}> Library closed</Typography> :
                                this.state.date !== null ? this.state.booking_slot_time.length === 0 && (<Typography style={{ float: "right", color: "red" }}> There is no library schedule for the day</Typography>) : null
                            }
                        </Typography>
                        <Grid container spacing={8}>
                            <Grid item xs={innerWidth > 480 ? 6 : 6} >
                                <form autoComplete="off">
                                    <FormControl className={classes.formControl} fullWidth>
                                        <InputLabel required shrink htmlFor="library_name" error={this.state.library_id_error === true ? true : false} >Library Name</InputLabel>
                                        <Select
                                            required
                                            fullWidth
                                            style={{ marginTop: 22 }}
                                            error={this.state.library_id_error === true ? true : false}
                                            value={this.state.library_id || ""}
                                            onChange={this.libraryDropDownAction}
                                            inputProps={{
                                                name: 'Library Name',
                                                id: 'library_name',
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        >
                                            {this.props.libraries.length > 0 && this.props.libraries.map(library => (
                                                <MenuItem key={library.id} value={library.id}>{library.library_name}</MenuItem>
                                            ))}

                                            {
                                                this.props.libraries.length === 0 &&
                                                <MenuItem key={0} value={0}>{`Select Library`}</MenuItem>
                                            }

                                        </Select>
                                        <FormHelperText error> {this.state.library_id_error === true ? "Please Select Library" : false} </FormHelperText>
                                    </FormControl>
                                </form>
                            </Grid>
                            <Grid item xs={6} >
                                <DatePicker
                                    id="standard-name"
                                    label=" Date"
                                    fullWidth
                                    className={classes.textField}
                                    disablePast={true}
                                    required
                                    error={this.state.date_error === true ? true : false}
                                    helperText={this.state.date_error === true ? "Please Enter Date" : false}
                                    value={this.state.date}
                                    onChange={this.dateChange}                                   
                                    margin="normal"
                                    formatDate={(date) => moment(date).format('YYYY-MM-DD')}
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            {this.state.booked_time.length > 0 ?
                                <Grid item xs={12}>
                                    {this.state.booked_time.length === 1 ? this.state.booked_time[0].status !== "REJECTED" ?
                                        <Typography style={{ marginLeft: 10, marginTop: -17 }}>Booked Time Slots : </Typography>
                                        : null
                                        : <Typography style={{ marginLeft: 10, marginTop: -17 }}>Booked Time Slots : </Typography>}
                                    <Grid container>
                                        {this.state.booked_time.map(time =>
                                            time.status !== "REJECTED" ?
                                                <Grid item xs={3} style={{ margin: 10 }}>
                                                    <Chip
                                                        label={`${moment(time.start_time).format('LT')} - ${moment(time.end_time).format('LT')}`}
                                                        style={{ color: time.status === "ACTIVE" ? "red" : time.status === "REQUESTED" ? "orange" : "#000", borderColor: time.status === "ACTIVE" ? "red" : time.status === "REQUESTED" ? "orange" : "#000" }}
                                                        variant="outlined"
                                                    />
                                                </Grid> : null)}
                                    </Grid>
                                </Grid> : null}
                            <Grid item xs={6} >
                                <TimePicker
                                    id="time"
                                    label="Start Time"
                                    fullWidth
                                    required
                                    className={classes.textField}
                                    value={this.state.start_time}
                                    onChange={(time) => this.setState({ start_time: this.returnStartTimeOREndTime(this.state.date,time), start_time_error: false })}
                                    helperText={this.state.start_time_error === true ? "Please enter start time" : false}
                                    error={this.state.start_time_error === true ? true : false}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    inputProps={{
                                        step: 300,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TimePicker
                                    id="time"
                                    label="End Time"
                                    fullWidth
                                    minDate={this.state.start_time}
                                    required
                                    className={classes.textField}
                                    value={this.state.end_time}
                                    onChange={(time) => this.setState({ end_time: this.returnStartTimeOREndTime(this.state.date,time), end_time_error: false, inavlid_end_time_error: false })}
                                    helperText={this.state.end_time_error === true ? "Please enter end time" : this.state.inavlid_end_time_error === true ? "Please enter valid time" : null}
                                    error={this.state.end_time_error === true ? true : this.state.inavlid_end_time_error === true ? true : false}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    inputProps={{
                                        step: 300,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 12 : 12} >
                                <TextField
                                    id="standard-name"
                                    label=" Booking Description"
                                    style={{ marginTop: 8 }}
                                    multiline
                                    fullWidth                                   
                                    value={this.state.description || ""}
                                    onChange={(event) => this.setState({ description: event.target.value, })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button onClick={this.handleClose} variant="contained" color="secondary" size="small" className={classes.cancelbutton}>
                                        cancel
                                    </Button>
                                    <Button onClick={this.bookingSessionFormSubmit} variant="contained" size="small" className={classes.button}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </BookingSessionModel>
            </div>
        );
    }
}

ClassView.propTypes = {
    classes: PropTypes.object.isRequired,

};

const mapStateToProps = (state) => {
    return {
        defaultRole: state.SessionReducer.defaultRole,
        users: state.UserReducer.users,
        classObject: state.ClassReducer.classesValue,
        programs: state.ProgramReducer.programs,
        bookedTimes: state.BookedReducer.bookedTimes,
        libraries: state.LibraryReducer.myLibrary,
        myTeam: state.TeamReducer.myTeam,
        bookingTimeSlot: state.BookingTimeSlotReducer.bookingTimeSlot,
        coaches: state.UserReducer.coaches
    }
}

export default compose(withStyles(styles), connect(mapStateToProps))(ClassView);


